import React from "react";
import ConfirmationModal from "app/components/common/ConfirmationModal";

const DiscardChangesModal = ({ show, onHide, onConfirm }) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title="Discard Changes and Leave?"
      confirmLabel="Leave"
      confirmVariant="danger"
    >
      <div className="pt-4">
        <p className="mb-2">You have unsaved changes.</p>
        <p className="mb-0">Do you want to leave without saving?</p>
      </div>
    </ConfirmationModal>
  );
};

export default DiscardChangesModal;
